<template>
  <div style="height:100%" id="container">
    <el-menu :default-active="active"
             :active="active"
             class="el-menu-vertical-demo"
             id="left-nav"
             background-color="#545c64"
             text-color="#fff"
             active-text-color="#ffd04b"
             @open="handleOpen"
             @close="handleClose"
             router
             unique-opened
             :collapse="isCollapse"
             :collapse-transition="false"
             ref="leftMenu"
    >
    <el-menu-item index="/">
      <i class="iconfont icon-ai-home" style="color:#909399;margin-right: 5px;"></i><router-link to="/">控制台首页</router-link>
    </el-menu-item>
    <el-submenu :index="key.menuCode" v-for="key in menuList" :key="key.menuCode" >
        <template slot="title">
            <i class="iconfont " :class=" key.iconUrl"></i>
            <span slot="title">{{key.menuName}}</span>
        </template>
            <el-menu-item :index="item.menuRouter"   v-for="item in key.children" :key="item.menuCode">
              {{item.menuName}}
          </el-menu-item>
      </el-submenu>

    </el-menu>
    <resize-observer @notify="handleResize" />
  </div>
</template>


<script>
import store from '../../store/store.js'
import 'vue-resize/dist/vue-resize.css'
import VueResize from 'vue-resize'
Vue.use(VueResize)
  export default {
    name: 'LeftNav',
    data() {
      return {
        // menuList: store.state.loginUserMenu[0].children,
        isCollapse: document.body.clientWidth < 1200 ?true :false,
        screenWidth : document.body.clientWidth,
        path:this.$route.path,
        default:'/'
      }
    },
    mounted: () => {
      let orderHight = document.documentElement.clientHeight;
      let bodyHight = document.body.clientHeight
      let containerHeight = document.getElementById('container').offsetHeight
      if(bodyHight>containerHeight){
        document.getElementById('container').style.height = (bodyHight-60)+'px'
      }
      document.getElementById('left-nav').style.height = '100%'
      
    },
    methods: {
      handleOpen(key, keyPath) {
      },
      handleClose(key, keyPath) {
      },
      handleResize() {
        this.isCollapse= document.body.clientWidth < 1200 ?true :false
        this.$store.state.isCollapse = document.body.clientWidth < 1200 ?true :false
        setTimeout(function(){
            document.getElementById('left-nav').style.height = '100%'
        },500)
      }
    },
    created(){
      this.$nextTick(()=>{
        if(this.path==this.default){
          this.$refs.leftMenu.open('YZZC')
        }
      })
    },
    computed:{
      active() {
        if(this.$route.path.split('/').length>2){
          return '/'+this.$route.path.split('/')[1]+'/'+this.$route.path.split('/')[2]
        }else{
          return '/'+this.$route.path.split('/')[1]
        }
      },
      menuList() {
        let array = []
        for(let i in store.state.loginUserMenu){
          if(store.state.loginUserMenu[i].menuCode == 'ZSTACK' || store.state.loginUserMenu[i].menuCode == 'PTGN'){
            let list = store.state.loginUserMenu[i].children
            for(let j in list){
              if(list[j].menuCode == 'DDZX'){

              }else if(list[j].menuCode == 'FYZX'){
                store.commit('updateCostMenu', list[j])
              }else if(list[j].menuCode == 'FYZX_FPGL'){

              }else if(list[j].menuCode == 'GRZX'){
                store.commit('updateUsercenterMenu', list[j])
              }else if(list[j].menuCode == 'GD'){
                store.commit('updateWorkorderMenuMenu', list[j])
              }else{
                array.push(list[j])
              }
            }
          }
        }
        
        return array
      }
    },
    watch: {
        '$store.state.isCollapse': function(val) {
          this.isCollapse = val
        }
    }
  };
</script>

<style lang='stylus' scoped>
    .left-nav
        height 100%
        float left
    .el-menu-vertical-demo:not(.el-menu--collapse) 
        width 180px
    .el-submenu
        // text-indent 20px
        text-align left
    a
      color #fff
      text-decoration none
      &:hover
        color #fff
        text-decoration none
</style>




// WEBPACK FOOTER //
// src/components/index/leftNav.vue